import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { WhatsAppIcon } from "./icons";
import { waLink, telLink } from "@/config";

export const Header = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="sticky top-0 z-40 bg-brandCream/85 backdrop-blur-md border-b border-brandSand/80"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
      <a href="#top" data-testid="brand-logo-link" className="transition-transform hover:scale-[1.02]">
        <Logo />
      </a>
      <div className="hidden md:flex items-center gap-4">
        <a
          data-testid="header-call-btn"
          href={telLink}
          className="text-sm font-medium hover:text-brandTerracotta transition-colors px-3 py-2"
        >
          Call Directly
        </a>
        <motion.a
          data-testid="header-wa-btn"
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          className="inline-flex items-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-medium px-5 py-2.5 rounded-full shadow-sm hover:shadow-md transition-shadow"
        >
          <WhatsAppIcon className="w-4 h-4" />
          Order on WhatsApp
        </motion.a>
      </div>
    </div>
  </motion.header>
);
